export const thumbnailsMetaData = {
    isRepeatable: false
}
